import Modal from './Modal';
import connectContainer from './ModalContainer';

export default connectContainer(Modal);
